var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPauseActiveHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 7,
    fill: "#0091EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 24.8H18.5V15.2H16.7V24.8ZM21.5 24.8H23.3V15.2H21.5V24.8ZM20 32C18.36 32 16.81 31.685 15.35 31.055C13.89 30.425 12.615 29.565 11.525 28.475C10.435 27.385 9.575 26.11 8.945 24.65C8.315 23.19 8 21.64 8 20C8 18.34 8.315 16.78 8.945 15.32C9.575 13.86 10.435 12.59 11.525 11.51C12.615 10.43 13.89 9.575 15.35 8.945C16.81 8.315 18.36 8 20 8C21.66 8 23.22 8.315 24.68 8.945C26.14 9.575 27.41 10.43 28.49 11.51C29.57 12.59 30.425 13.86 31.055 15.32C31.685 16.78 32 18.34 32 20C32 21.64 31.685 23.19 31.055 24.65C30.425 26.11 29.57 27.385 28.49 28.475C27.41 29.565 26.14 30.425 24.68 31.055C23.22 31.685 21.66 32 20 32ZM20 30.2C22.84 30.2 25.25 29.205 27.23 27.215C29.21 25.225 30.2 22.82 30.2 20C30.2 17.16 29.21 14.75 27.23 12.77C25.25 10.79 22.84 9.8 20 9.8C17.18 9.8 14.775 10.79 12.785 12.77C10.795 14.75 9.8 17.16 9.8 20C9.8 22.82 10.795 25.225 12.785 27.215C14.775 29.205 17.18 30.2 20 30.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseActiveHover);
export default __webpack_public_path__ + "static/media/pauseActiveHover.a431ee2a7de15d433750f4fd3a106bbc.svg";
export { ForwardRef as ReactComponent };